export default __webpack_public_path__ + "static/media/blue-gradient-box.64d81e89.svg";